import { SITE_URL } from '../../constants'
import { buildCaseStudySchema } from '../../builders/caseStudy'
import { PageMeta } from '../../types'

const description =
  '銀行口座アプリのUIデザインを担当しました。デザイン思考のアプローチで元々あった機能一覧を再考し、モック制作、ユーザー調査からコンセプトを再設計して、UIデザインまで実施しました。'

const ogpImg = 'https://aitria.co.jp/images/img/cases/nri/ogp_nri.png'

export const nriPageMeta: PageMeta = {
  title: '東京スター銀行アプリ | 事例 | Aitria（アイトリア）',
  description,
  keyword: 'UX/UI モバイルアプリ システム化 DX推進 フロントエンド開発',
  image: ogpImg,
  url: `${SITE_URL}/cases/nri/`,
}

export const nriSchema = buildCaseStudySchema({
  slug: 'nri',
  pageTitle: nriPageMeta.title,
  description: nriPageMeta.description,
  headline: '東京スター銀行アプリ',
  alternativeHeadline: '株式会社野村総合研究所',
  primaryImage: ogpImg,
  images: [ogpImg, 'https://aitria.co.jp/images/img/cases/caseStudyTop/nri.webp'],
  clientName: '株式会社野村総合研究所',
  breadcrumbLabel: '東京スター銀行アプリ',
})
